import css from 'styled-jsx/css';

export default css`
  .moduloPlan {
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    border-radius: 16px;
    :global(.imgPlan) {
      border-radius: 16px;
    }
    :global(.cobertura) {
      margin-bottom: 10px;
      margin-top: 30px;
    }
    .containerPrices {
      display: flex;
      align-items: baseline;
      gap: 10px;
      margin-bottom: 20px;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloPlan {
      min-width: 19rem;
      :global(.title) {
        font-size: 24px;
      }
      :global(.cobertura) {
        font-size: 16px;
      }
    }
  }
`;
